"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.SELECT_ALL_ID = exports.ORDER = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _Button = _interopRequireDefault(require("../Button"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var baseCls = 'lt-switcher';

// Item with this id will be treated as select all
var SELECT_ALL_ID = exports.SELECT_ALL_ID = 'ANY';
var ORDER = exports.ORDER = {
  ASC: 'asc',
  // ascending order
  DESC: 'desc' // descending order
};
var notSelected = function notSelected(item) {
  return !item.selected;
};
var itemDisabled = function itemDisabled(item) {
  return item.disabled || item.id === SELECT_ALL_ID;
};
var Switcher = function Switcher(_ref) {
  var list = _ref.list,
    order = _ref.order,
    onChange = _ref.onChange,
    isMobile = _ref.isMobile,
    className = _ref.className;
  var reverse = order === ORDER.DESC;
  var items = reverse ? (0, _toConsumableArray2["default"])(list).reverse() : list;
  var allDisabled = list.every(itemDisabled);
  var hasActive = false;
  var itemList = items.flatMap(function (item, itemIndex) {
    var selected = item.selected,
      disabled = item.disabled,
      id = item.id,
      label = item.label;
    if (label == 'Любой' && isMobile) return [];
    var active = false;
    if (!allDisabled) {
      hasActive = hasActive || selected;
      var selectAll = id === SELECT_ALL_ID;
      active = selectAll ? list.every(notSelected) : hasActive && !disabled || selected;
    }
    var handleClick = function handleClick(e) {
      e.preventDefault();
      onChange(item);
    };
    return [/*#__PURE__*/_react["default"].createElement(StyledSwitcherItem, {
      key: id,
      className: active ? "".concat(baseCls, "-item__active") : null,
      active: active,
      disabled: disabled && !allDisabled,
      onClick: handleClick,
      $isMobile: isMobile
    }, label)];
  });
  return /*#__PURE__*/_react["default"].createElement(StyledSwitcher, {
    className: className,
    $reverse: reverse,
    $isMobile: isMobile
  }, itemList);
};
var StyledSwitcherItem = (0, _styledComponents["default"])(_Button["default"]).attrs({
  functional: true
}).withConfig({
  displayName: "Switcher__StyledSwitcherItem",
  componentId: "sc-1lq6k1f-0"
})(["display:flex;justify-content:center;align-items:center;padding:0 8px;flex-shrink:0;background-color:var(--background);border-radius:var(--border-radius);color:var(--black);font-size:14px;font-style:normal;font-weight:400;line-height:16px;", " ", " ", ""], function (_ref2) {
  var $isMobile = _ref2.$isMobile;
  return $isMobile && (0, _styledComponents.css)(["flex-grow:1;padding:0;font-size:16px;line-height:20px;"]);
}, function (_ref3) {
  var active = _ref3.active;
  return active && (0, _styledComponents.css)(["background-color:var(--secondary);color:var(--secondary-color);"]);
}, function (_ref4) {
  var disabled = _ref4.disabled;
  return disabled && (0, _styledComponents.css)(["opacity:var(--disabled-opacity);"]);
});
var StyledSwitcher = _styledComponents["default"].div.withConfig({
  displayName: "Switcher__StyledSwitcher",
  componentId: "sc-1lq6k1f-1"
})(["display:flex;gap:4px;height:32px;", " ", ";"], function (_ref5) {
  var $isMobile = _ref5.$isMobile;
  return $isMobile && (0, _styledComponents.css)(["height:44px;margin-left:10px;margin-right:10px;"]);
}, function (_ref6) {
  var $reverse = _ref6.$reverse;
  return $reverse && (0, _styledComponents.css)(["flex-direction:row-reverse;justify-content:flex-end;"]);
});
Switcher.propTypes = {
  className: _propTypes["default"].string,
  list: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    id: _propTypes["default"].string.isRequired,
    label: _propTypes["default"].string.isRequired,
    selected: _propTypes["default"].bool,
    disabled: _propTypes["default"].bool
  })).isRequired,
  onChange: _propTypes["default"].func.isRequired,
  order: _propTypes["default"].oneOf(Object.values(ORDER)),
  isMobile: _propTypes["default"].bool
};
Switcher.defaultProps = {
  className: '',
  order: ORDER.ASC,
  isMobile: false
};
var _default = exports["default"] = Switcher;